export default "__VITE_ASSET__BnR3VDue__"